import { render, staticRenderFns } from "./ProductViewEN.vue?vue&type=template&id=b2dbfc66&scoped=true&"
import script from "./ProductViewEN.vue?vue&type=script&lang=js&"
export * from "./ProductViewEN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dbfc66",
  null
  
)

export default component.exports